import { render, staticRenderFns } from "./AddEmployerUserForm.vue?vue&type=template&id=0bd5cc0b&scoped=true"
import script from "./AddEmployerUserForm.vue?vue&type=script&lang=ts"
export * from "./AddEmployerUserForm.vue?vue&type=script&lang=ts"
import style0 from "./AddEmployerUserForm.vue?vue&type=style&index=0&id=0bd5cc0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5cc0b",
  null
  
)

export default component.exports